<template>
  <div class="current-live-shopping" v-if="liveScheduleDTOs.length > 0">
    <h2>{{$t('commimgLiveVideo')}}</h2>
    <ul class="tv_shop_listing" v-if="liveScheduleDTOs.length > 0">
      <li v-for="(liveScheduleDTO,index) in liveScheduleDTOs" :key="index" @click="goToProductDetail(liveScheduleDTO.itemLiveDTOs[0].saleReferenceID)">
        <div class="list-item">
          <div class="list-img" v-if="liveScheduleDTO.itemLiveDTOs[0].displayImage">
            <img :src="liveScheduleDTO.itemLiveDTOs[0].displayImage" alt />
            <span class="language">{{liveScheduleDTO.langName}}</span>
            <span class="user-profile">
              <img :src="liveScheduleDTO.hostPicture" alt />
            </span>
          </div>
          <div class="list-content" v-if="liveScheduleDTO.itemLiveDTOs[0].productName">
            <p class="list-title">{{liveScheduleDTO.itemLiveDTOs[0].productName}}</p>
            <div class="list-price flx">
              <span>₹​ {{liveScheduleDTO.itemLiveDTOs[0].sellingPrice}}</span>
              <strike>₹​ {{liveScheduleDTO.itemLiveDTOs[0].mrp}}</strike>
            </div>
            <div class="time_view">
              <div class="time_out">
                 <Timer
                  @StopTime="timerStop"
                  :timing="getTime(liveScheduleDTO.liveStartTimeMilis,index)"
                  :Index="index"
                  :GroupID="liveScheduleDTO.liveStartTimeMilis"
                />
              </div>
              <span class="view_prod">{{$t('viewProduct')}}</span>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import ImageSpinner from "../Common/ImageSpinner";
import Timer from "../Common/TimeCount";
export default {
  name: "UpcomingLive",
  components: { ImageSpinner, Timer },
  props: {
    liveScheduleDTOs: {
      required: true,
      type: Array
    }
  },
  data() {
    return {};
  },
  methods: {
    goToProductDetail(productSrId) {
      this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
           window.location.reload()
        }
      });
      this.$router.push("/detail/" + productSrId);
    },
    getTime(value, index) {
      let milliseconds = Number(value) / 1000;
      return milliseconds;
    },
    timerStop(obj) {
      if(this.liveScheduleDTOs.length > 0){
      this.liveScheduleDTOs[obj.index].status = false;
      }
    },
  },
  mounted() {}
};
</script>
